import React, { Component } from 'react';
import MapDisplay from './MapDisplay'
import UserReg from './userReg';
export class Home extends Component {
  displayName = Home.name

  render() {
    return (
      <div>
        <MapDisplay />
        <UserReg/> 
      </div>
    );
  }
}
